import InstaceAxios  from "./Api";

export const getModalidadesEmpresa = async () => {
    const result = await InstaceAxios.get(`modalidad/empresa`)
        .then(res => res)
        .catch(error => error)
    return result
}